module.exports = __webpack_public_path__ + "static/Avatar-54ddcfbb7364388b7eb91a4ab2c5acdc.png";